<azavista-icon-button *ngIf="chatBotSvc.isDisplayed$()" (click)="close()" icon="close" color="primary"></azavista-icon-button>
